import React, { useEffect, useState } from "react";

import {
  Coffee,
  Share as ShareIcon,
  VolunteerActivism,
  X,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Link,
  Paper,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import Container from "@mui/material/Container";
import { blueGrey } from "@mui/material/colors";

import i18n from "../i18n";

export default function Footer({ generateShareURL }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(/Android|iPhone|iPad|iPod/i.test(navigator.userAgent));
  }, []);

  return (
    <>
      <Box
        position="fixed"
        bottom={0}
        left={0}
        right={0}
        sx={{ backgroundColor: "white", zIndex: 1300 }}
      >
        <Paper elevation={5}>
          <Container maxWidth="lg">
            <Grid container paddingY={1}>
              <Grid item xs={5}>
                <Button
                  onClick={async () => {
                    const url = generateShareURL();
                    if (isMobile) {
                      try {
                        await navigator.share({
                          url,
                          title: "検索結果の共有",
                          text: "検索結果を共有します。",
                        });
                      } catch (err) {
                        console.error("共有に失敗しました", err);
                      }
                    } else {
                      try {
                        await navigator.clipboard.writeText(url);
                        setSnackbarOpen(true);
                      } catch (err) {
                        console.error("コピーに失敗しました", err);
                      }
                    }
                  }}
                  startIcon={<ShareIcon />}
                  sx={{ color: blueGrey[700] }}
                >
                  検索結果を共有
                </Button>
              </Grid>
              <Grid item xs={2} display="flex" justifyContent="center">
                <IconButton
                  sx={{ padding: 0 }}
                  href="https://x.com/ptcgdatabase"
                  target="_blank" // 新しいタブで開く
                  rel="noopener noreferrer" // セキュリティ対策
                >
                  <X />
                </IconButton>
              </Grid>
              <Grid
                item
                xs={5}
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Link
                  href={
                    i18n.language === "ja"
                      ? "https://note.com/riddles/n/ned811ccf2dd3"
                      : "https://ko-fi.com/daichipdb"
                  }
                  color="text.secondary"
                  target="_blank" // 新しいタブで開く
                  rel="noopener noreferrer" // セキュリティ対策
                >
                  <Stack direction="row" gap={0.3}>
                    {i18n.language === "ja" ? (
                      <>
                        <VolunteerActivism fontSize="small" />
                        <Typography variant="body2">ご支援はこちら</Typography>
                      </>
                    ) : (
                      <>
                        <Coffee fontSize="small" />
                        <Typography variant="body2">Buy me a coffee</Typography>
                      </>
                    )}
                  </Stack>
                </Link>
              </Grid>
            </Grid>
          </Container>
        </Paper>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message="リンクをコピーしました"
      />
    </>
  );
}
